import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import Select2 from "../../../../components/common/select/Select2";
import { Field } from "redux-form";
import { required } from "../../../../utils/forms/validators";
// import styles from "./FilterBox.scss";

const CATEGORIES = [{ id: 1, value: "Invoice Status" }];

class FilterBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: -1
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: this.props.selected });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: nextProps.selected });
    }
  }

  onChange(value) {
    this.setState({ selectedCategory: value });
  }

  renderInvoiceStatus() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.status_id`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.statusOptions}
      />
    );
  }

  renderCriteria() {
    switch (this.state.selectedCategory) {
      case 1:
        return this.renderInvoiceStatus();
      default:
        return null;
    }
  }

  render() {
    return (
      <Row>
        <Col xs={12} md={5}>
          <Field
            validate={required}
            name={this.props.name}
            type="select"
            placeholder="Category"
            component={Select2}
            options={CATEGORIES}
            onSelectChange={this.onChange}
          />
        </Col>
        <Col xs={12} md={7}>
          {this.renderCriteria()}
        </Col>
      </Row>
    );
  }
}

export default FilterBox;



// WEBPACK FOOTER //
// ./src/routes/admin/invoices/components/FilterBox.js